import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getLandsCadastralCases(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASES,
		options
	)
}

function _getLandsCadastralCase(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE,
		options
	)
}

function _createLandsCadastralCase(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].CREATE_LANDS_CADASTRAL_CASE,
		options
	)
}

function _putLandsCadastralCase(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PUT_LANDS_CADASTRAL_CASE,
		options
	)
}

function _patchLandsCadastralCase(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PATCH_LANDS_CADASTRAL_CASE,
		options
	)
}

function _deleteLandsCadastralCase(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].DELETE_LANDS_CADASTRAL_CASE,
		options
	)
}

function _getLandsCadastralCasePreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_PREVIEW,
		options
	)
}

function _getLandsCadastralCasePopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_POPUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASES]: _getLandsCadastralCases,

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE]: _getLandsCadastralCase,
	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_PREVIEW]: _getLandsCadastralCasePreview,
	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_POPUP]: _getLandsCadastralCasePopup,

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].CREATE_LANDS_CADASTRAL_CASE]: _createLandsCadastralCase,
	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PUT_LANDS_CADASTRAL_CASE]: _putLandsCadastralCase,
	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PATCH_LANDS_CADASTRAL_CASE]: _patchLandsCadastralCase,
	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].DELETE_LANDS_CADASTRAL_CASE]: _deleteLandsCadastralCase,
}